"use strict";

var _regeneratorRuntime = require("/app/front/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/app/front/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/app/front/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/app/front/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wombat = void 0;

var core_1 = __importDefault(require("@scatterjs/core"));

var eosjs2_1 = __importDefault(require("@scatterjs/eosjs2"));

var universal_authenticator_library_1 = require("universal-authenticator-library");

var WombatIcon_1 = require("./WombatIcon");

var WombatUser_1 = require("./WombatUser");

var UALWombatError_1 = require("./UALWombatError");

var Wombat = /*#__PURE__*/function (_universal_authentica) {
  _inherits(Wombat, _universal_authentica);

  var _super = _createSuper(Wombat);

  /**
   * Scatter Constructor.
   *
   * @param chains
   * @param options { appName } appName is a required option to use Scatter
   */
  function Wombat(chains, options) {
    var _this;

    _classCallCheck(this, Wombat);

    _this = _super.call(this, chains);
    _this.users = [];
    _this.scatterIsLoading = false;
    _this.initError = null;

    if (options && options.appName) {
      _this.appName = options.appName;
      _this.magicLink = options.magicLink;
    } else {
      throw new UALWombatError_1.UALWombatError('Scatter requires the appName property to be set on the `options` argument.', universal_authenticator_library_1.UALErrorType.Initialization, null);
    }

    return _this;
  }
  /**
   * Checks Scatter for a live connection.  Will set an Initialization Error
   * if we cannot connect to scatter.
   */


  _createClass(Wombat, [{
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.scatterIsLoading = true;
                core_1.default.plugins(new eosjs2_1.default()); // set an errored state if scatter doesn't connect

                _context.next = 4;
                return core_1.default.scatter.connect(this.appName);

              case 4:
                if (_context.sent) {
                  _context.next = 8;
                  break;
                }

                this.initError = new UALWombatError_1.UALWombatError('Error occurred while connecting', universal_authenticator_library_1.UALErrorType.Initialization, null);
                this.scatterIsLoading = false;
                return _context.abrupt("return");

              case 8:
                this.scatter = core_1.default.scatter;
                window.ScatterJS = null;
                this.scatterIsLoading = false;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "reset",
    value: function reset() {
      this.initError = null; // eslint-disable-next-line @typescript-eslint/no-floating-promises

      this.init();
    }
  }, {
    key: "isLoading",
    value: function isLoading() {
      return this.scatterIsLoading;
    }
  }, {
    key: "isErrored",
    value: function isErrored() {
      return !!this.initError;
    }
  }, {
    key: "getError",
    value: function getError() {
      return this.initError;
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      return {
        icon: WombatIcon_1.WombatIcon,
        text: 'Wombat',
        textColor: '#FFFFFF',
        background: '#f43e27'
      };
    }
  }, {
    key: "shouldRender",
    value: function shouldRender() {
      return Wombat.isDappBrowser() || !!this.magicLink || window.innerWidth > 700;
    }
  }, {
    key: "shouldAutoLogin",
    value: function shouldAutoLogin() {
      return false;
    }
  }, {
    key: "login",
    value: function login() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _iterator, _step, chain, user;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.users = [];
                _context2.prev = 1;
                _iterator = _createForOfIteratorHelper(this.chains);
                _context2.prev = 3;

                _iterator.s();

              case 5:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 13;
                  break;
                }

                chain = _step.value;
                user = new WombatUser_1.WombatUser(chain, this.scatter);
                _context2.next = 10;
                return user.getKeys();

              case 10:
                this.users.push(user);

              case 11:
                _context2.next = 5;
                break;

              case 13:
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](3);

                _iterator.e(_context2.t0);

              case 18:
                _context2.prev = 18;

                _iterator.f();

                return _context2.finish(18);

              case 21:
                return _context2.abrupt("return", this.users);

              case 24:
                _context2.prev = 24;
                _context2.t1 = _context2["catch"](1);
                throw new UALWombatError_1.UALWombatError('Unable to login', universal_authenticator_library_1.UALErrorType.Login, _context2.t1);

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 24], [3, 15, 18, 21]]);
      }));
    }
    /**
     * Call logout on scatter.  Throws a Logout Error if unsuccessful
     */

  }, {
    key: "logout",
    value: function logout() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                this.scatter.logout();
                _context3.next = 7;
                break;

              case 4:
                _context3.prev = 4;
                _context3.t0 = _context3["catch"](0);
                throw new UALWombatError_1.UALWombatError('Error occurred during logout', universal_authenticator_library_1.UALErrorType.Logout, _context3.t0);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 4]]);
      }));
    }
    /**
     * Scatter provides account names so it does not need to request it
     */

  }, {
    key: "shouldRequestAccountName",
    value: function shouldRequestAccountName() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", false);

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
  }, {
    key: "getOnboardingLink",
    value: function getOnboardingLink() {
      return 'https://getwombat.io/';
    }
  }, {
    key: "requiresGetKeyConfirmation",
    value: function requiresGetKeyConfirmation() {
      return false;
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'wombat';
    }
  }], [{
    key: "isDappBrowser",
    value: function isDappBrowser() {
      var userAgent = window.navigator.userAgent;
      return userAgent.toLowerCase().includes('wombat');
    }
  }]);

  return Wombat;
}(universal_authenticator_library_1.Authenticator);

exports.Wombat = Wombat;